// Code de la ressource 'Livret d'Accueil'
export const CodeLivretAccueil: string = "1LIVRET_ACCUEIL";

// Lint ne permet pas d'avoir un seul export non défini en default
// On est donc obligé de définir un default tant que l'on exporte qu'une constante
export default CodeLivretAccueil;
